import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { WeUseCookies } from "../../components/popups/WeUseCookies";
import { SearchAndFilterDialog } from "../../components/popups/SearchAndFilter";
import { links } from "common-frontend-components";
import { searchAndFilterDialogStore } from "../../stores/searchAndFilterDialogStore";
import { useOnLazyPageLoad } from "../../hooks/useOnAppLoad";
export const WwwSearchPage = () => {
    useOnLazyPageLoad();
    const [didOpen, setDidOpen] = useState(false);
    const isOpen = searchAndFilterDialogStore.useOpen();
    useEffect(() => {
        searchAndFilterDialogStore.open();
        setDidOpen(true);
    }, []);
    useEffect(() => {
        if (didOpen && !isOpen) {
            links.goBackOrHome();
        }
    }, [didOpen, isOpen]);
    return (_jsxs(_Fragment, { children: [_jsx(SearchAndFilterDialog, {}, void 0), _jsx(WeUseCookies, {}, void 0)] }, void 0));
};
//# sourceMappingURL=WwwSearchPage.js.map